import Service from "../../Service";

const resource = "HmnRequirementApproval/";

export default {
  save(item, requestID) {
    console.log("saveBatch", list, reqID, requestID);
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "paginate", parameters, {
      params: { requestID: requestID },
    });
  },
  byReqID(reqID, requestID) {
    return Service.post(resource + "byReqID", null, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  saveBatch(list, reqID, requestID) {
    console.log("saveBatch", list, reqID, requestID);
    
    return Service.post(resource + "saveBatch", list, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  saveCircuitMulti(payload, requestID) {
    return Service.post(resource + "saveCircuitMulti", payload, {
      params: { requestID: requestID },
    });
  },
  approve(item, requestID) {
    return Service.post(resource + "approve", item, {
      params: { requestID: requestID },
    });
  },
  approveBatch(payload, requestID) {
    return Service.post(resource + "approveBatch", payload, {
      params: { requestID: requestID },
    });
  },
  sendBatch(reqIDs, requestID) {
    return Service.post(resource + "sendBatch", reqIDs, {
      params: { requestID: requestID },
    });
  },
  getCircuit(reqID, reqPstID, requestID) {
    return Service.post(resource + "getCircuit", null, {
      params: { reqID: reqID, reqPstID: reqPstID, requestID: requestID },
    });
  },
};
